import { Stack } from '../Stack';
import { styled } from '../styled';
import { Colors } from '../theme';

import { DropzoneState } from './types';

const getColor = (props: DropzoneState, isError?: Boolean) => {
  if (props.isDragAccept) {
    return Colors.blue600;
  }
  if (props.isDragReject) {
    return Colors.red500;
  }
  if (isError) {
    return Colors.red500;
  }
  if (props.isFocused) {
    return Colors.blue600;
  }

  return Colors.blue300;
};

export const ContainerStyled = styled('div')<
  DropzoneState & { showFiles: Boolean; isError?: Boolean }
>(({ theme, showFiles, isError, ...props }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  borderWidth: 1,
  borderRadius: 12,
  borderColor: getColor(props, isError),
  borderStyle: 'dashed',
  outline: 'none',

  '.filesUpload-content': {
    padding: 16,
  },

  '.filesUpload-arrowFile': {
    rotate: showFiles ? '-180deg' : 0,
  },

  '.filesUpload-title': {
    lineHeight: '140%',
  },

  '.link-label': {
    lineHeight: '140%',
  },
}));

export const LineStyled = styled('div')(() => ({
  backgroundColor: Colors.gray200,
  height: 1,
}));

export const DragActiveStyled = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: 72,
  paddingBottom: 72,
  borderRadius: 12,
  backgroundColor: Colors.gray50,
}));

export const StyledStack = styled(Stack)(() => ({
  width: '100%', // to make the "Add" button grow full width
}));
